define('app/sdc/datetime/sdc-datetime',["service!selcomm", "filter!date", "service!dateParser", "$mdUtil", "$timeout"], function (SelcommWS, dateFilter, dateParser, $mdUtil, $timeout) {
	"use strict";
	return {
		// Require specifies controllers to look for
		// These will be bound to your controller on PostLink (After the constructor)
		require: {
			"ngModel": "?ngModel",
			"mdInputContainer": "^^?mdInputContainer"
		},
		controller: {
			// Bind attributes here
			bind: {
				"_format": "@format",
				"disabled": "=?ngDisabled",
				"precision": "@?"
			},
			// Define functions here and default properties that are simple types (not objects or arrays)
			prototype: {
				options: {
					minMode: "month"
				},
				isOpen: false,
				parse: function (text) {
					if (!angular.isDate(text)) {
						return dateParser.parse(text, this.format);
					}
					else {
						return text;
					}
				},
				format: function (value) {
					return dateFilter(this.parse(value), this._format);
				},
				open: function (event) {
					this.isOpen = true;
					$timeout(function () {
						$timeout(function () {
							event.target.focus();
						}, false);
					}, false);
				},
				onKeyPress: function (event) {
					if (event.keyCode === 13 && !this.disabled) {
						this.isOpen = false;
					}
					//else {
					//	this.isOpen = true;
					//}
				}
			},
			// Define properties with getter/setters
			properties: {
				textValue: {
					get: function () {
						return this.ngModel.$viewValue;
					},
					set: function (value) {
						return this.ngModel.$setViewValue(value);
					}
				},
				disabled: {
					get: function () {
						return this._disabled;
					},
					set: function (value) {
						if (!value) {
							this.isOpen = false;
						}
						this._disabled = false;
					}
				},
				ngModelOptions: function () {
					var vm = this;
					if (!this._ngModelOptions || Object.getPrototypeOf(this._ngModelOptions) !== (this.ngModel && this.ngModel.$options || undefined)) {
						var debounce;
						this._ngModelOptions = Object.create(this.ngModel && this.ngModel.$options || Object.prototype, {
							allowInvalid: { value: false },
							getterSetter: { value: false },
							debounce: {
								get: function () {
									if (!debounce || Object.getPrototypeOf(debounce) !== Object.getPrototypeOf(vm._ngModelOptions).debounce || undefined) {
										debounce = Object.create(vm._ngModelOptions && Object.getPrototypeOf(vm._ngModelOptions).debounce || Object.prototype, {
											"default": {
												get: (function () {
													if (vm._ngModelOptions && ("default" in Object.getPrototypeOf(vm._ngModelOptions.debounce))) {
														return Object.getPrototypeOf(vm._ngModelOptions).debounce.default;
													}
													else {
														return 200;
													}
												}).bind(this)
											}
										});
									}
								}
							}
						});
					}
					return this._ngModelOptions;
				}
			},
			// Define the constructor, the parameters here are injected, you must use injection to get any of the following
			// $scope, $element, $attrs, $transclude
			// Also note that controllers from the require property will not exist at this stage and are only added after linking
			constructor: ["$scope", "$element", "$attrs", "$transclude", "$self", function ($scope, $element, $attrs, $transclude, vm) {
				function precisionVal(precisionName) {
					switch (precisionName.toLowerCase()) {
						case "year": return 5;
						case "month": return 4;
						case "day": return 3;
						case "hour": return 2;
						case "minute": return 1;
						case "second": return 0;
					}
				}
				if (!"precision" in $attrs) {
					if (!(!/H|h|m|s|a|Z/.test(this._format)) && /y|M/.test(this._format)) {
						this.precision = "year to month";
					}
				}
				var precision = (this.precision || "year to day").split(/\s+to\s+/i);
				switch (precision.length) {
					case 1:
						precision = {
							minMode: precision[0],
							maxMode: "year"
						};
						break;
					case 2:
						precision = {
							minMode: precision[0],
							maxMode: precision[1]
						}
						break;
					default:
						precision = null;
				}
				if (precision) {
					if (precisionVal(precision.minMode) > precisionVal(precision.maxMode)) {
						var min = precision.minMode;
						precision.minMode = precision.maxMode;
						precision.maxMode = min;
					}
					precision.datepickerMode = precision.minMode;
				}
				else {
					precision = {};
				}
				this.options = angular.extend({

				}, precision);
			}]
		},
		link: ["$self", "$controllers", "$attrs", function (vm, $controllers, $attrs) {
			var ngModel = $controllers.ngModel = $controllers.ngModel || $mdUtil.fakeNgModel();
			ngModel.$formatters.push(vm.format.bind(vm));
			ngModel.$parsers.push(vm.parse.bind(vm));
			if ($controllers.mdInputContainer) {
				$attrs.$addClass("sdc-input-group");
			}
		}]
	}
});
